export { getQuizApi, passQuizApi, getQuizAttemptApi } from './api/quiz.api';
export type { AnswerPayload, AnswerResultDTO } from './api/quiz.api';

export { assessmentQuestionsLengths, assessmentQuestionsAmount } from './config/assessment';

export { useActiveQuiz } from './hooks/useActiveQuiz';

export { useQuizStore } from './model/store';
export type { QuestionType, Quiz, Question, Answer, AttemptPrice } from './model/types';

export { default as MultipleQuestion } from './ui/MultipleQuestion/MultipleQuestion';
export { default as SingleQuestion } from './ui/SingleQuestion/SingleQuestion';
export { default as TextQuestion } from './ui/TextQuestion/TextQuestion';
